const CLEARTRIP = 'CLEARTRIP'
const FLYIN = 'FLYIN'

export { CLEARTRIP, FLYIN }
